import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-config-management",
	templateUrl: "./config-management.component.html",
	styleUrls: ["./config-management.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class ConfigManagementComponent {
	api = inject(ApiService);
}
